<template lang="pug">
  div
    el-row(type="flex" justify="end")
      el-button.create-button(type="primary" @click="openEventDialog") {{ $t('Cuona.Event.new') }}
    .content
      EventsTable.group(:events="events" :edit="false" :isGroupHidden="false" :loading="isLoading" :actions="actions")

    event-dialog
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import actions from '@/utils/defines/actions.js'
import EventApi from '@/api/event'
import EventsTable from '../EventsTable'
import EventDialog from './EventDialog'
export default {
  mixins: [actions],
  components: {
    EventsTable,
    'event-dialog': EventDialog
  },
  data () {
    return {
      isLoading: true,
      events: []
    }
  },
  computed: {
    ...mapState({
      coupons: state => state.plugin.coupons
    }),

    ...mapGetters([
      'company',
    ]),

    isShowingDialog() {
      return this.$store.state.event_ui.showingEventDialog;
    }
  },
  title() {
    return this.$t('menus.event')
  },
  mounted() {
    this.getEvents();
  },
  methods: {
    getEvents: function (){
      const that = this;
      EventApi.getEvents()
        .then(function(values) {
          that.events = values;
        })
        .catch((error) => {
          this.$message({
            showClose: true,
            message: this.$t('Cuona.Event.failed_get'),
            type: 'error'
          });
        })
        .finally(() => { this.isLoading = false; });
    },

    openEventDialog() {
      this.$store.dispatch('showEventDialog');
    }
  },
  watch: {
    isShowingDialog(val) {
      if (!val) {
        this.getEvents();
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../styles/variables.scss";
  @import "../../../styles/table-layout.scss";

  .el-dialog .content {
    margin: 0;
  }

  a {
    transition: all .3s ease-in-out;
    color: #666;
    &:hover {
      color: $safe;
    }
  }

  .create-button {
    margin: 20px 40px -20px;
  }

  .group {
    margin-right: 3px;

    &:last-child {
      margin-right: 0;
    }
  }
</style>
